import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { withRouter } from 'react-router'
import getStrings from 'getStrings'
import { updateIntegrations } from "../../Uluweb"
import { loginWithEmailAddress, executeAddOrUpdateUser } from "../../Playfab"
import getUrlParameters from 'getUrlParameters'
import getWidgetsOrigin from '../getWidgetsOrigin'
import ReactGA from "react-ga4"
import getErrorMessage from 'getErrorMessage'
import AppContext from 'core/appContext'

class WidgetsSignInForm extends React.Component {

    constructor(props) {
        super(props)

        const origin = getWidgetsOrigin()
        console.log('widget origin: ', origin)

        let parentOrigin
        if (origin === 'web2wave')
            parentOrigin = 'https://ululab.web2wave.com'
        else if (origin === 'funnelululabcom')
            parentOrigin = 'https://funnel.ululab.com'
        else if (origin === 'quizululabcom')
            parentOrigin = 'https://quiz.ululab.com'
        else if (origin === 'quizdevululabcom')
            parentOrigin = 'https://quizdev.ululab.com'
        else if (origin === 'quizgabrielululabcom')
            parentOrigin = 'https://quizgabriel.ululab.com'

        this.state = {
            parentOrigin: parentOrigin
        }
    }

    signInClicked = async (event) => {
        event.preventDefault()

        if (!document.forms[event.target.dataset.form].reportValidity()) return        // EXIT

        const callerFormName = event.target.dataset.form
        const formData = this.getFormDataJSON(callerFormName)

        if (!this.state.parentOrigin) {
            alert('Invalid parent origin!')
            this.blockUI(true)
            return
        }

        if (!formData.Email || !formData.Password) { // It should only get on browsers that don't support .reportValidity() (Mobile Firefox)
            alert('All fields are required')
            return  // EXIT
        }
        
        this.blockUI(true)

        const playfabAPIResponse = await this.tryLoginWithEmailAddress(formData.Email, formData.Password)
        if (!playfabAPIResponse) // Playfab returned an error and has already shown the error message to the client
            return  // EXIT

        if (playfabAPIResponse.status !== 200) {
            // this is the only error returned by PlayFab on this call: https://docs.microsoft.com/en-us/rest/api/playfab/client/authentication/login-with-email-address?view=playfab-rest
            this.displayError('InvalidEmailOrPassword')
        } else {
            const uluwebToken = uuidv4()
            let userID
            let playfabID

            try {

                playfabID = playfabAPIResponse.data.data.PlayFabId
                const entityToken = playfabAPIResponse.data.data.EntityToken.EntityToken
                const updateUserResponse = await this.tryUpdateUser(entityToken, uluwebToken, playfabID)

                if (!updateUserResponse?.success) {
                    this.blockUI(false)
                    return
                }

                userID = updateUserResponse.id
            } catch (err) {
                console.error(err)
                this.displayError('GENERIC_ERROR')
                this.blockUI(false)
                return
            }

            const sessionObject = {
                ...playfabAPIResponse.data,
                token: uluwebToken,
                email: formData.Email
            }

            ReactGA.event('sign_in', sessionObject)

            await updateIntegrations(uluwebToken)

            console.log('sending session message. session: ', JSON.stringify(sessionObject))
            window.parent.postMessage(
                {
                    type: "AUTH_SUCCESS",
                    session: JSON.stringify(sessionObject),
                    userID: userID,
                    playfabID: playfabID
                },
                this.state.parentOrigin
            )
        }
        
        this.blockUI(false)
    }

    tryUpdateUser = async (entityToken, uluwebToken, playfabID) => {
        try {
            const response = await executeAddOrUpdateUser(entityToken, uluwebToken, playfabID, false)

            if (!response.data.data.FunctionResult.success)
                this.displayError(response.data.data.FunctionResult.error)
            else if (!response.data.data.FunctionResult.userAPIResponse.success)
                this.displayError(response.data.data.FunctionResult.userAPIResponse.error)
            else
                return response.data.data.FunctionResult.userAPIResponse
        } catch (err) {
            console.error(err)
            this.displayError(err)
        }
    }

    tryLoginWithEmailAddress = async (email, password) => {
        try {
            return await loginWithEmailAddress(email, password)
        } catch (err) {
            this.blockUI(false)
            this.displayError(err.response.data.error)
        }
    }

    getFormDataJSON = (formName) => Object.fromEntries(new FormData(document.forms[formName]).entries())

    blockUI = (shouldBlock) => this.context.setBlockUI(shouldBlock)

    displayError = (errorCode) => {
        const strings = getStrings()
        if (!errorCode || Object.keys(errorCode).length === 0) {
            console.error('signin.displayError: generic: ', errorCode)
            return alert(strings.PARENT_PORTAL_MANAGE_ACCOUNT_ERROR_GENERIC_ERROR)
        }

        console.error(`signin.displayError: ${errorCode}`)
        alert(getErrorMessage('PARENT_PORTAL_SIGN_IN_FORM_ERROR_', errorCode, strings))
    }

    render() {
        const strings = getStrings()

        return (
            <>
                <div className='form-box'>
                    <form id='formSignIn'>
                        <input name='Email' type='email' placeholder={strings.PARENT_PORTAL_FORM_EMAIL} required className='margin-bottom-2' />
                        <input name='Password' type='password' placeholder={strings.PARENT_PORTAL_SIGN_IN_FORM_PASSWORD} required className='margin-bottom-2' />
                        <p className='margin-bottom-2 text-right'>
                            <a href={`/signin?${getUrlParameters()}`} target={'_blank'}>{strings.PARENT_PORTAL_SIGN_IN_FORM_FORGOT_PASSWORD_LINK}</a>
                        </p>
                        <button 
                            data-form='formSignIn'
                            onClick={this.signInClicked.bind(this)}
                            className="form-button"
                            type='button'
                            style={{ backgroundColor: '#FF9408' }}
                        >
                            {strings.PARENT_PORTAL_SIGN_IN_FORM_BUTTON}
                        </button>
                    </form>
                </div>
            </>
        )
    }
}

WidgetsSignInForm.contextType = AppContext

export default withRouter(WidgetsSignInForm)